import {
  Card,
  Container,
  Stack,
  Typography,
  Button,
  Backdrop,
  CircularProgress,
  Alert
} from '@mui/material';
import React, { useEffect } from 'react';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import QuickSearchToolbar from '../utils/search_toolbar';
import { allBettors, bettorsSelector } from '../slices/bettorSlice';

import Page from '../components/Page';
import { ApiStatus, escapeRegExp } from '../utils/constants';

function Bettors() {
  const { bettors, status, errorMessage } = useSelector(bettorsSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(allBettors());
  }, []);

  useEffect(() => {
    if (bettors) {
      const updatedBettors = bettors.map((bettor, index) => ({
        ...bettor,
        index: index + 1
      }));
      setRows(updatedBettors);
    }
  }, [bettors]);

  const [searchText, setSearchText] = React.useState('');
  const [rows, setRows] = React.useState([]);

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), 'i');
    const filteredRows = bettors.filter((row) =>
      Object.keys(row).some(
        (field) => row[field] !== null && searchRegex.test(row[field].toString())
      )
    );
    setRows(filteredRows);
  };

  const columns = [
    {
      field: 'id',
      headerName: 'Sr. No',
      width: 90,
      renderCell: (params) => <Typography>{params.row.index}</Typography>
    },
    {
      field: 'name',
      headerName: 'Name',
      width: 200
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 200
    },
    {
      field: 'followedCappers',
      headerName: 'Followed Cappers',
      width: 200,
      renderCell: (params) => <Typography>{params.row.followingCappers.length}</Typography>
    },
    {
      field: 'tipsPurchased',
      headerName: 'Tips Purchased',
      width: 200,
      renderCell: (params) => <Typography>{params.row.tipsPurchased.length}</Typography>
    }
  ];

  return (
    <Page title="Cappers">
      <Backdrop style={{ zIndex: 100, color: '#fff' }} open={status === ApiStatus.loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {errorMessage && errorMessage.length && <Alert severity="error">{errorMessage}</Alert>}
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Bettors
          </Typography>
        </Stack>
        <Card>
          <DataGrid
            components={{ Toolbar: QuickSearchToolbar }}
            autoHeight
            rows={rows}
            columns={columns}
            pageSize={50}
            rowsPerPageOptions={[50]}
            checkboxSelection
            disableSelectionOnClick
            componentsProps={{
              toolbar: {
                value: searchText,
                onChange: (event) => requestSearch(event.target.value),
                clearSearch: () => requestSearch('')
              }
            }}
          />
        </Card>
      </Container>
    </Page>
  );
}
export default Bettors;
